import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-3f09952a"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "chat-page",
  ref: "chatPage"
};
const _hoisted_2 = {
  class: "chatContents"
};
const _hoisted_3 = {
  class: "chat-item-question"
};
const _hoisted_4 = {
  class: "chat-item-answer"
};
const _hoisted_5 = {
  class: "noData"
};
const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "请问有什么可以帮助您的吗?", -1));
const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "hiddenBlock",
  style: {
    "height": "80px"
  }
}, null, -1));
const _hoisted_8 = {
  key: 1,
  class: "stopBtn"
};
const _hoisted_9 = {
  class: "content"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_MarkdownRenderer = _resolveComponent("MarkdownRenderer");
  const _component_van_notice_bar = _resolveComponent("van-notice-bar");
  const _component_van_cell_group = _resolveComponent("van-cell-group");
  const _component_van_list = _resolveComponent("van-list");
  const _component_van_pull_refresh = _resolveComponent("van-pull-refresh");
  const _component_speechTextCompVue = _resolveComponent("speechTextCompVue");
  const _component_van_button = _resolveComponent("van-button");
  const _component_van_image = _resolveComponent("van-image");
  const _component_van_col = _resolveComponent("van-col");
  const _component_van_tag = _resolveComponent("van-tag");
  const _component_van_cell = _resolveComponent("van-cell");
  const _component_van_row = _resolveComponent("van-row");
  const _component_van_swipe_cell = _resolveComponent("van-swipe-cell");
  const _component_van_popup = _resolveComponent("van-popup");
  return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", _hoisted_1, [_withDirectives(_createElementVNode("section", _hoisted_2, [_createVNode(_component_van_pull_refresh, {
    modelValue: $data.loadPageing,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => $data.loadPageing = $event),
    onRefresh: $options.loadMoreContent,
    "success-text": "正在加载中...",
    disabled: $data.listIsOver
  }, {
    default: _withCtx(() => [_createVNode(_component_van_list, {
      loading: $data.loadPageing,
      "onUpdate:loading": _cache[0] || (_cache[0] = $event => $data.loadPageing = $event),
      finished: $data.listIsOver,
      disabled: true,
      "finished-text": "没有更多了",
      "loading-text": " ",
      onLoad: $options.getChatHistory
    }, {
      default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.chatContents, item => {
        return _openBlock(), _createBlock(_component_van_cell_group, {
          inset: "",
          key: item.id,
          style: {
            "margin-bottom": "10px"
          }
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", null, _toDisplayString(item.question), 1)]), _createElementVNode("div", _hoisted_4, [_withDirectives(_createVNode(_component_MarkdownRenderer, {
            "markdown-content": item.answer
          }, null, 8, ["markdown-content"]), [[_vShow, item.correct]]), _withDirectives(_createVNode(_component_van_notice_bar, {
            "left-icon": "info-o",
            background: "#fffbe8",
            color: "#ed6a0c",
            wrapable: "",
            scrollable: false
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(item.answer), 1)]),
            _: 2
          }, 1536), [[_vShow, !item.correct]])])]),
          _: 2
        }, 1024);
      }), 128))]),
      _: 1
    }, 8, ["loading", "finished", "onLoad"])]),
    _: 1
  }, 8, ["modelValue", "onRefresh", "disabled"])], 512), [[_vShow, $data.chatContents.length > 0]]), _withDirectives(_createElementVNode("div", _hoisted_5, [_createElementVNode("p", null, " 您好，我是「" + _toDisplayString(_ctx.getCurrTeam.team_name) + "」对话机器人！我是由JoinMC知识库和我们的团队知识库共同打造的机器人。除了可以回答您的专业问题之外，还可以陪您聊天！ ", 1), _hoisted_6], 512), [[_vShow, $data.chatContents.length === 0]])], 512), _hoisted_7, !$data.gptLoading ? (_openBlock(), _createBlock(_component_speechTextCompVue, {
    key: 0,
    ref: "speechTextComp",
    chatGptModelId: $data.gpt_model_id || '',
    showChoosed: $data.chatContents.length > 0,
    gptActions: $options.gptModelsActions,
    onGetInputValue: $options.sendMessage,
    onGetChangedModel: $options.getChangedModel
  }, null, 8, ["chatGptModelId", "showChoosed", "gptActions", "onGetInputValue", "onGetChangedModel"])) : (_openBlock(), _createElementBlock("div", _hoisted_8, [_createVNode(_component_van_button, {
    type: "warning",
    icon: "pause-circle-o",
    block: "",
    onClick: _cache[2] || (_cache[2] = $event => $options.closeAI())
  }, {
    default: _withCtx(() => [_createTextVNode("停止生成")]),
    _: 1
  })])), _createVNode(_component_van_popup, {
    show: $data.showLeft,
    "onUpdate:show": _cache[6] || (_cache[6] = $event => $data.showLeft = $event),
    position: "left",
    style: {
      width: '90%',
      height: '100%'
    },
    onClose: $options.closeLeftPopup,
    class: "chat-left-panel"
  }, {
    default: _withCtx(() => [_createElementVNode("section", _hoisted_9, [_createVNode(_component_van_cell_group, {
      inset: "",
      style: {
        "padding": "10px",
        "margin-bottom": "10px"
      }
    }, {
      default: _withCtx(() => [_createVNode(_component_van_row, {
        align: "center"
      }, {
        default: _withCtx(() => [_createVNode(_component_van_col, {
          span: "5"
        }, {
          default: _withCtx(() => [_createVNode(_component_van_image, {
            round: "",
            src: _ctx.$store.state.user_info.head_img_url
          }, null, 8, ["src"])]),
          _: 1
        }), _createVNode(_component_van_col, {
          offset: "2",
          span: "16"
        }, {
          default: _withCtx(() => [_createVNode(_component_van_cell, {
            title: _ctx.$store.state.user_info.nick_name
          }, {
            label: _withCtx(() => [_createVNode(_component_van_tag, {
              type: "success"
            }, {
              default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.gptConfigDatas.pandagpt_team_users_role[_ctx.getCurrTeam.role]), 1)]),
              _: 1
            })]),
            _: 1
          }, 8, ["title"])]),
          _: 1
        })]),
        _: 1
      }), _createVNode(_component_van_button, {
        block: "",
        type: "primary",
        onClick: _cache[3] || (_cache[3] = $event => $options.newChat())
      }, {
        default: _withCtx(() => [_createTextVNode("新建对话")]),
        _: 1
      })]),
      _: 1
    }), _createVNode(_component_van_pull_refresh, {
      modelValue: $data.refreshing,
      "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => $data.refreshing = $event),
      onRefresh: $options.onRefresh,
      "success-text": "正在刷新..."
    }, {
      default: _withCtx(() => [_createVNode(_component_van_list, {
        class: "swipe-cell-list",
        loading: $data.loading,
        "onUpdate:loading": _cache[4] || (_cache[4] = $event => $data.loading = $event),
        finished: $data.finished,
        "finished-text": "没有更多了",
        onLoad: $options.onLoad
      }, {
        default: _withCtx(() => [_createVNode(_component_van_cell_group, {
          inset: ""
        }, {
          default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.list, item => {
            return _openBlock(), _createBlock(_component_van_swipe_cell, {
              key: item.id,
              "before-close": args => $options.handleBeforeClose(args, item)
            }, {
              right: _withCtx(() => [_createVNode(_component_van_button, {
                square: "",
                type: "danger",
                text: "删除"
              })]),
              default: _withCtx(() => [_createVNode(_component_van_cell, {
                border: false,
                title: item.sess_name,
                icon: "chat-o",
                onClick: () => $options.handleSwipeCellClick(item)
              }, null, 8, ["title", "onClick"])]),
              _: 2
            }, 1032, ["before-close"]);
          }), 128))]),
          _: 1
        })]),
        _: 1
      }, 8, ["loading", "finished", "onLoad"])]),
      _: 1
    }, 8, ["modelValue", "onRefresh"])])]),
    _: 1
  }, 8, ["show", "onClose"])], 64);
}